// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ak5MD","colBig":"styles_colBig__14iQT","colSmall":"styles_colSmall__5dG0s"};